module.exports = __webpack_public_path__ + "static/media/mapa-a5.cbb24050.png";